module.exports = __webpack_public_path__ + "66382b72af78fa3c857db4d211e8626b.png";